import { Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { IMAGES } from "../../lib/site";
import { useLang } from "../../lib/i18n";

export const TaxiShowcase = () => {
    const { t } = useLang();
    const images = [IMAGES.passat, IMAGES.lynk];

    return (
        <section id="onze-taxi" data-testid="taxi-section" className="relative overflow-hidden bg-night-900/40 py-24 sm:py-32">
            <div className="container-x">
                <SectionHeading
                    num="02"
                    eyebrow={t.taxi.eyebrow}
                    title={t.taxi.title}
                    text={t.taxi.text}
                />
                <div className="mt-14 grid gap-8 lg:grid-cols-2">
                    {t.taxi.vehicles.map((vehicle, i) => (
                        <Reveal key={vehicle.plate} delay={0.12 * i}>
                            <article
                                data-testid={`vehicle-card-${i}`}
                                className="card-lift h-full overflow-hidden rounded-3xl border border-white/8 bg-night-850/80"
                            >
                                <div className="relative">
                                    <img
                                        src={images[i]}
                                        alt={vehicle.alt}
                                        data-testid={`vehicle-image-${i}`}
                                        className="aspect-[4/3] w-full object-cover object-center"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-night-950/85 via-night-950/10 to-transparent" />
                                    <div className="absolute bottom-4 left-5 right-5 flex items-end justify-between gap-3">
                                        <h3 className="font-display font-wide text-xl font-extrabold uppercase text-white sm:text-2xl">
                                            {vehicle.name}
                                        </h3>
                                        <span className="font-mono text-xs text-amber-300">{vehicle.code}</span>
                                    </div>
                                </div>
                                <div className="p-7 sm:p-8">
                                    <div className="flex flex-wrap items-center gap-3.5">
                                        <span className="plate" data-testid={`vehicle-plate-${i}`}>{vehicle.plate}</span>
                                        <span className="max-w-xs text-sm text-slate-400">{vehicle.tagline}</span>
                                    </div>
                                    <div className="mt-6 grid grid-cols-3 gap-3" data-testid={`vehicle-specs-${i}`}>
                                        {vehicle.specs.map((spec) => (
                                            <div key={spec.label} className="rounded-xl border border-white/8 bg-night-900/70 px-2 py-4 text-center">
                                                <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-slate-500">{spec.label}</p>
                                                <p className="mt-1.5 font-display font-wide text-base font-extrabold uppercase text-amber-400 sm:text-lg">
                                                    {spec.value}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                    <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-testid={`vehicle-features-${i}`}>
                                        {vehicle.features.map((feature) => (
                                            <li key={feature} className="flex items-center gap-2.5 text-sm text-slate-300">
                                                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-400/12 text-amber-400">
                                                    <Check size={12} strokeWidth={3} />
                                                </span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
